'use client'

import React from 'react'
import { Link } from '@/i18n/routing'
import { Category, Media } from '@/payload-types'
import { getCategoryHref } from '@/utilities/categoryHref'
import classes from './CategoryCard.module.css'
import gridClasses from './index.module.css'



const UNDERLAYER_COLORS = [
  '#f97316', // 0
  '#10b981', // 1
  '#a855f7', // 2
  '#f97316', // 3
  '#6366f1', // 4
  '#10b981', // 5
  '#a855f7', // 6
  '#f97316', // 7
]

type CategoryCardProps = {
  category: Category
  index: number
}

const CategoryCard = ({ category, index }: CategoryCardProps) => {
  const media = category.media as Media | null

  // Hover direction per index — always pushes OUTWARD from the grid
  // ┌──────────┬────────┬────────┐
  // │ 0 ↖ diag │ 1 ↑ up │ 2 ↗   │  Row 1
  // │ TL       │        │ diag TR│
  // │          ├────────┼────────┤
  // │          │ 3 🔄   │ 4 → R  │  Row 2
  // │          │ rotate │        │
  // ├────┬─────┼────────┴────────┤
  // │5 ↙ │6 ↓  │     7 ↘         │  Row 3
  // │ BL │down │    diag BR      │
  // └────┴─────┴─────────────────┘
  const HOVER_CLASSES = [
    classes.hoverDiagTL,  // 0 Angebote   — top-left corner → diagonal top-left
    classes.hoverUp,      // 1 Headshop   — top row center  → up
    classes.hoverDiagTR,  // 2 Flohmarkt  — top-right corner → diagonal top-right
    classes.hoverRotate,  // 3 CBD        — inner center     → tilt/rotate
    classes.hoverRight,   // 4 Ethnobotanik — right edge     → right
    classes.hoverDiagBL,  // 5 Growshop   — bottom-left corner → diagonal bottom-left
    classes.hoverDown,    // 6 Hanfpflanzen — bottom center  → down
    classes.hoverDiagBR,  // 7 Hanfsamen  — bottom-right    → diagonal bottom-right
  ]

  const SPAN_CLASSES = [
    gridClasses.spanLarge, // 0
    gridClasses.spanSmall, // 1
    gridClasses.spanSmall, // 2
    gridClasses.spanSmall, // 3
    gridClasses.spanSmall, // 4
    gridClasses.spanSmall, // 5
    gridClasses.spanSmall, // 6
    gridClasses.spanWide,  // 7
  ]

  const hoverClass = HOVER_CLASSES[index % HOVER_CLASSES.length]

  const underlayerColor = UNDERLAYER_COLORS[index % UNDERLAYER_COLORS.length]
  const spanClass = SPAN_CLASSES[index % SPAN_CLASSES.length]
  const titleClass = index === 0 ? `${classes.cardTitle} ${classes.titleLarge}` : classes.cardTitle

  return (
    <div className={`${classes.cardWrapper} ${spanClass}`}>
      <div
        className={classes.underlayer}
        style={{ backgroundColor: underlayerColor }}
      />
      <Link
        href={getCategoryHref(category)}
        className={`${classes.card} ${hoverClass}`}
        data-testid="category-card"
      >
        {media?.url && (
          <div
            className={classes.cardImage}
            style={{ backgroundImage: `url(${media.url})` }}
          />
        )}
        <div className={classes.cardBody}>
          <h3 className={titleClass}>{category.title}</h3>
        </div>
      </Link>
    </div>
  )
}

export default CategoryCard
